import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { checkUserLoggedIn } from "../shared copy/commonfunctions";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { sendEmialAPICall } from "../shared copy/APICalls";
import { ISendEmail } from "../shared copy/dtos";
import routesData from "../shared copy/routes.json";
import YourDetailsStyles from "../pages copy/Styles/YourDetails.module.scss";
import YourdetailsImage from "../Components copy/assets/Images/newLeftImage.svg";
import googleImage from "../Components copy/assets/Images/goggle.png";
import ContinueWithGoogle from "../Components copy/ContinueWithGoogle/ContinueWithGoogle";
import SnackBar from "../Components copy/SnackBars/SnackBar";
import mobileviewimage from "../Components copy/assets/Images/mobileviewgiftbox.svg";

export default function YourDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { validationID } = state;
  const [emailAddress, setemailAddress] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<any>(false);
  const [message, setMessage] = useState<any>("");
  const [loading, setloading] = useState(false);

  const navigationData:any = routesData;

  // console.log("validationID", validationID);

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
  }, []);

  function sendEmailAddress(name: any, emailid: any) {
    let obj: ISendEmail = {
      // validation_id: validationID,
      email: emailid,
      client_name: name,
      is_gmail_verified: false,
      google_client_id: "",
    };
    sendEmialAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log(response, "response");

        setloading(false);

        if (
          responseData.data.stage &&
          navigationData.hasOwnProperty(responseData.data.stage)
        ) {
          navigate(navigationData[responseData.data.stage], {
            state: { emailID: emailid, validateID: validationID },
          });
        }
      })
      .catch((error: any) => {
        setloading(false);
        // console.log("error", error);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.error.message
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
        // if (error.response.data.error.message) {
        //   setMessage(error.response.data.error.message);
        //   setloading(false);
        //   setErrorMessage(true);
        //   setTimeout(() => {
        //     setMessage("");
        //   }, 5000);
        // }
      });
  }

  const handleClick = () => {
    navigate("/confirmemailotp");
  };
  const callBackMessage = (data: any) => {
    setMessage(data);
  };

  function validateName(value: any) {
    let error: any;
    if (!value) {
      error = "Name Required";
    } else if (!/^[a-zA-Z\s]{1,50}$/.test(value)) {
      error = "Extra characters not allowed";
    }
    return error;
  }

  function validateEmail(value: any) {
    let error: any;
    if (!value) {
      error = "Email Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      error = "Invalid email address";
    } else if (value.length > 75) {
      error = "Not a valid email address";
    }
    return error;
  }

  return (
    <>
      <div className={YourDetailsStyles.mobileHeader}>
        <p className={YourDetailsStyles.LeftContainerHeadermobileHeader}>
          Welcome to Firstock Partners
        </p>
        <p className={YourDetailsStyles.LeftContainerSubTextmobileHeader}>
          Just a couple of clicks and we start.
        </p>
      </div>
      <div className={YourDetailsStyles.wrapper}>
        <div className={YourDetailsStyles.LeftContainer}>
          <p className={YourDetailsStyles.LeftContainerHeader}>
            Welcome to Firstock Partners
          </p>
          <p className={YourDetailsStyles.LeftContainerSubText}>
            Just a couple of clicks and we start.
          </p>
          <img
            src={YourdetailsImage}
            alt="Image"
            className={YourDetailsStyles.image}
          />
        </div>
        <div className={YourDetailsStyles.RightContainer}>
          <div className={YourDetailsStyles.headerSection}>
            <p className={YourDetailsStyles.signup}>
              Enter Your Email Address{" "}
            </p>
            <p className={YourDetailsStyles.subText}>
              All account related information will be sent to this address.
            </p>
          </div>

          <div>
            <Formik
              initialValues={{
                name: "",
                email: "",
              }}
              onSubmit={(values) => {
                //  console.log(values);
                setloading(true);
                setemailAddress(values.email);
                sendEmailAddress(values.name, values.email);
              }}
            >
              {({ errors, touched, handleChange, values, handleSubmit }) => (
                <Form
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                    // event.code.includes("Enter") && handleSubmit()
                  }}
                >
                  <div className={YourDetailsStyles.textfeildSection}>
                    {/* <Typography variant="h5"> Your Details </Typography> */}

                    <Field
                      name="name"
                      validate={validateName}
                      render={({ field }:any) => (
                        <TextField
                          {...field}
                          className={YourDetailsStyles.textfeild}
                          id="outlined-basic"
                          label="Enter your full name as per your PAN"
                          variant="outlined"
                          InputProps={{
                            maxLength: 50,
                          }}
                          // helperText={
                          //   errors.name &&
                          //   touched.name && (
                          //     <FormHelperText style={{ color: "#d32f2f" }}>
                          //       {errors.name}
                          //     </FormHelperText>
                          //   )
                          // }
                        />
                      )}
                    />

                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "12px",
                        height: "10px",
                        padding: "5px 0px 0px 15px",
                      }}
                    >
                      {errors.name && touched.name && errors.name}
                    </div>

                    <Field
                      name="email"
                      validate={validateEmail}
                      render={({ field }:any) => (
                        <TextField
                          {...field}
                          className={YourDetailsStyles.textfeild}
                          id="outlined-basic"
                          label="Enter your Email Id"
                          variant="outlined"
                          InputProps={{
                            maxLength: 75,
                          }}
                          // helperText={
                          //   errors.email &&
                          //   touched.email && (
                          //     <FormHelperText style={{ color: "#d32f2f" }}>
                          //       {errors.email}
                          //     </FormHelperText>
                          //   )
                          // }
                        />
                      )}
                    />
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "12px",
                        height: "10px",
                        padding: "5px 0px 0px 15px",
                      }}
                    >
                      {errors.email && touched.email && errors.email}
                    </div>

                    {/* <FormHelperText style={{ color: "#d32f2f" }}>
                    {message}
                  </FormHelperText> */}

                    <SnackBar message={message} />

                    <div className={YourDetailsStyles.mobileImage}>
                      <img
                        src={mobileviewimage}
                        alt="Image"
                        className={YourDetailsStyles.imageMobileView}
                      />
                    </div>

                    <div className={YourDetailsStyles.buttonSection}>
                      <ContinueWithGoogle
                        validationID={validationID}
                        handleCallBack={callBackMessage}
                      />
                      <Typography sx={{ fontSize: "12px", margin: "10px 0px" }}>
                        (or)
                      </Typography>
                      {values.name && values.email ? (
                        <LoadingButton
                          variant="contained"
                          type="submit"
                          loading={loading}
                          id="yourDetailsContinueButton"
                          className={YourDetailsStyles.button}
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Continue
                        </LoadingButton>
                      ) : (
                        <Button
                          variant="contained"
                          disabled
                          className={YourDetailsStyles.button}
                        >
                          Continue
                        </Button>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}
